import cookie from '../../../utils/cookie';

import store from '@/store'

export function getToken() {
  let cookiesValue = cookie.get("PIE_MALL_Token");
  if (cookiesValue) {
    return cookiesValue
  } else {
    // 写死token便于开发阶段地测试  上传代码记得更改!!!
    // return '8672966ce203fa46d1352f7b2994b335';
    return '';
  }
}

export function getAccount() {
  return store.state.account
}

// 切换环境返回值
export function getIsStage() {
  return 'PROD';
  // return 'TEST';
}

export function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

export function getUUID() {
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export function removeToken() {
  return cookie.remove("PIE_MALL_Token")
}

export function getXapp() {
  return 'a908215bce7511f4e2d20deed3d6cb3c';
}

export function getXsecretKey() {
  return 'a1cbfef404f2eeed1e1fc29dc9607e70';
}

export function setXapp(Xapp) {
  return cookie.Xapp = Xapp
}

export function removeXapp() {
  return cookie.remove('Xapp')
}
